import { SuperbatchResourceRecorder } from '../src/SuperbatchResourceRecorder.ts';

export const superbatchCSSRecorder: SuperbatchResourceRecorder = new SuperbatchResourceRecorder(
	false,
);
export const superbatchJSRecorder: SuperbatchResourceRecorder = new SuperbatchResourceRecorder(
	true,
);
